import React, { useCallback, useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const ACTIVIDADES = [{
  src: 'https://cdn.magicpatterns.com/uploads/fc6DaPsVJZCK1NbCM6heFt/actividad_economia_1.png',
  alt: 'Actividad de Economía 1 - El problema económico y la escasez'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3MzS5vQwVp9u5Yyuiovk1E/actividad_economia_2.png',
  alt: 'Actividad de Economía 2 - Gasto público: funciones y efectos'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/uGp1bAUzHvFYrMmNP5VNKJ/actividad_economia_3.png',
  alt: 'Actividad de Economía 3 - Productividad y competitividad empresarial'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/6idfnBHqmp6TkkVgbSG7rD/actividad_economia_4.png',
  alt: 'Actividad de Economía 4 - Crédito y financiamiento'
}];
export function ActividadesCarousel() {
  const [current, setCurrent] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const goTo = useCallback((index: number) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrent(index);
    setTimeout(() => setIsTransitioning(false), 500);
  }, [isTransitioning]);
  const next = useCallback(() => {
    goTo((current + 1) % ACTIVIDADES.length);
  }, [current, goTo]);
  const prev = useCallback(() => {
    goTo((current - 1 + ACTIVIDADES.length) % ACTIVIDADES.length);
  }, [current, goTo]);
  // Auto-advance every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      next();
    }, 4000);
    return () => clearInterval(interval);
  }, [next]);
  const scrollToOffer = () => {
    const element = document.getElementById('oferta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-8 sm:py-16 bg-[#0f172a] border-t border-gray-800" data-id="element-14">
      <div className="max-w-4xl mx-auto px-3 sm:px-6" data-id="element-15">
        <div className="text-center mb-6 sm:mb-10" data-id="element-16">
          <h2 className="text-lg sm:text-3xl md:text-4xl font-bold text-white mb-2 sm:mb-4" data-id="element-17">
            Estas son algunas de las actividades que encontrarás en el{' '}
            <span className="text-[#fbbf24]" data-id="element-18">Kit Completo de Economía</span>
          </h2>
        </div>

        {/* Carousel */}
        <div className="relative" data-id="element-19">
          {/* Main Image */}
          <div className="relative overflow-hidden rounded-xl shadow-2xl border-2 border-gray-700 bg-white cursor-pointer" onClick={scrollToOffer} data-id="element-20">
            <div className="relative w-full" style={{
            minHeight: '300px'
          }} data-id="element-21">
              {ACTIVIDADES.map((act, index) => <div key={index} className={`absolute inset-0 transition-all duration-500 ease-in-out ${index === current ? 'opacity-100 translate-x-0' : index < current ? 'opacity-0 -translate-x-full' : 'opacity-0 translate-x-full'}`} data-id="element-22">
                  <img src={act.src} alt={act.alt} className="w-full h-auto" data-id="element-23" />
                </div>)}
              {/* Static sizing image (invisible, just for height) */}
              <img src={ACTIVIDADES[0].src} alt="" className="w-full h-auto invisible" aria-hidden="true" data-id="element-24" />
            </div>
          </div>

          {/* Navigation Arrows */}
          <button onClick={prev} className="absolute left-2 sm:left-3 top-1/2 -translate-y-1/2 bg-[#0a1628]/80 hover:bg-[#0a1628] text-white p-1.5 sm:p-2 rounded-full shadow-lg transition-all z-10 border border-gray-600" aria-label="Anterior" data-id="element-25">
            <ChevronLeft className="w-4 h-4 sm:w-6 sm:h-6" data-id="element-26" />
          </button>
          <button onClick={next} className="absolute right-2 sm:right-3 top-1/2 -translate-y-1/2 bg-[#0a1628]/80 hover:bg-[#0a1628] text-white p-1.5 sm:p-2 rounded-full shadow-lg transition-all z-10 border border-gray-600" aria-label="Siguiente" data-id="element-27">
            <ChevronRight className="w-4 h-4 sm:w-6 sm:h-6" data-id="element-28" />
          </button>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-4" data-id="element-29">
            {ACTIVIDADES.map((_, index) => <button key={index} onClick={() => goTo(index)} className={`w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full transition-all duration-300 ${index === current ? 'bg-[#fbbf24] scale-125 shadow-[0_0_8px_rgba(251,191,36,0.5)]' : 'bg-gray-600 hover:bg-gray-400'}`} aria-label={`Ir a actividad ${index + 1}`} data-id="element-30" />)}
          </div>
        </div>

        {/* CTA below carousel */}
        <div className="text-center mt-6 sm:mt-8" data-id="element-31">
          
        </div>
      </div>
    </section>;
}